import styled from 'styled-components';

import Input from 'components/ui/Input';

import { colours } from 'themes/default';

export const Title = styled.p`
  font-weight: bold;
  margin: 0;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 160px;
  padding: 16px;
  background-color: ${colours.Greyscale.MistGrey};
`;

export const StyledInput = styled(Input)`
  margin-top: 24px;
  padding: 0;
  height: 44px;
  width: 50px;
  text-align: center;
  border: 1px solid ${colours.Greyscale.CloudGrey};
`;

export const SubtitleList = styled.ul`
  margin: 0;
  padding: 0 0 0 16px;
`;

export const SubtitleItem = styled.li`
  font-size: 12px;
  margin: 0;
  color: ${colours.Greyscale.CharcoalGrey};
`;

export const SingleSubtitle = styled.p`
  font-size: 14px;
  margin: 0;
  color: ${colours.Greyscale.CharcoalGrey};
`;
